/**
 * @author wuTao
 * @description 同步数据提前处理列表
 * @Date 2023/07/18
 */
import React from 'react';
import {connect} from 'dva';
import {reduxTemplateCofig, templateConfig} from './config'

import {framework_tool} from '@/tool';

let {WizContainer, WizReduxTemplate} = framework_tool;

class UserMerge extends WizContainer {

  componentName = 'UserMerge';

  constructor(props) {
    super(props);
    this.state = {}
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig({
        _this: this,
      }),
      apiDataFormat: {
        add:this._handleCMD,
        update:this._handleCMD,
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(UserMerge);
